import { productListApi } from 'app/pages/ProductList/slice';
import { xmlFeedApi } from 'app/pages/ProductList/slice/xmlFeedApi';
import { api as loginApi } from 'app/pages/Login/slice';
import { api as resetPasswordApi } from 'app/pages/ResetPassword/slice';
import { api as profileSettingsApi } from 'app/pages/ProfileSettings/slice';
import { api as templateSettingApi } from 'app/pages/TemplateSetting/slice';
import { employeesApi } from 'app/pages/Employees/slice';
import { api as arSettingsApi } from 'app/pages/ARSettings/slice';
import { api as analyticsApi } from 'app/pages/Analytics/slice';
import { localizationApi } from 'app/pages/LocalizationManagement/slice';
import { globalApi } from 'app/slice';
import { dashboardApi } from 'app/pages/Dashboard/slice';
import { renderLogsApi } from 'app/pages/RenderLogs/slice';

export const rtkQueryMiddleware = [
  productListApi,
  xmlFeedApi,
  loginApi,
  resetPasswordApi,
  profileSettingsApi,
  templateSettingApi,
  employeesApi,
  arSettingsApi,
  analyticsApi,
  localizationApi,
  globalApi,
  dashboardApi,
  renderLogsApi,
].map(d => d?.middleware);
